import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './App.jsx';
import './i18n/index.js';
import './assets/styles/global.css';
import './assets/styles/components.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: 'var(--elvyra-surface-2)',
            color: 'var(--elvyra-text-primary)',
            border: '1px solid var(--elvyra-border)',
            fontFamily: 'var(--font-primary)',
          },
          success: { iconTheme: { primary: 'var(--elvyra-success)', secondary: '#fff' } },
          error:   { iconTheme: { primary: 'var(--elvyra-danger)',  secondary: '#fff' } },
        }}
      />
    </BrowserRouter>
  </React.StrictMode>
);
